var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgILaboratory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.852 51.571l-15.464-8.931 1.532-2.651 15.461 8.931z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.631 56.656c4.466-4.218 7.296-10.144 7.296-16.758 0-8.149-4.28-15.499-10.935-19.627l7.456-12.906-1.171-0.675 1.839-3.198-4.821-2.783-1.843 3.193-1.233-0.712-18.33 31.752 1.601 0.924-2.273 3.932 4.028 2.326 2.274-3.934 1.599 0.924 7.708-13.349c4.726 3.013 7.759 8.292 7.759 14.134 0 9.24-7.522 16.758-16.763 16.758-6.187 0-13.506 0-13.506 0v6.345h38.018v-6.345c-0 0-5.629 0-8.701 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.883 7.865v-5.037h0.62l-0.009-1.208h-5.649l0.009 1.208h0.666v5.037h-4.215v-5.037h0.618l-0.007-1.208h-5.654l0.011 1.208h0.666v5.037h-6.189v25.231h25.269v-25.231h-6.134zM23.879 30.96h-20.992v-20.959h4.051v16.12c0 1.22 0.997 2.211 2.2 2.211 1.205-0.005 2.166-0.993 2.166-2.211v-16.12h4.215v16.12c0 1.22 0.998 2.211 2.201 2.211 1.205-0.005 2.166-0.993 2.164-2.211v-16.12h3.995v20.959h0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILaboratory);
export default __webpack_public_path__ + "static/media/i-laboratory.aa24fc42.svg";
export { ForwardRef as ReactComponent };